import { RecentlyVisitedApp } from "components/RecentlyVisitedApps";
import { FavoriteApp } from "components/FavoritesApps";
import { ClientApp } from "models";
import React, { FC } from "react";
import { Avatar } from "react-toolbox/lib/avatar";

export interface AppIconProps {
    app: ClientApp | RecentlyVisitedApp | FavoriteApp;
}

const AppIcon: FC<AppIconProps> = (props: AppIconProps) => {
    const { app } = props;

    if (app) {
        if (app.smallIcon) {
            return <Avatar image={app.smallIcon} />;
        } else {
            return <Avatar title={app.name} />;
        }
    } else {
        return <Avatar image="/img/xapp-logo-teal.svg" />;
    }
};

export { AppIcon };
